import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib'
import VueTheMask from 'vue-the-mask'

Vue.use(Vuetify)
Vue.use(VueTheMask)

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  }
});
